import { render, staticRenderFns } from "./LinkAccount.vue?vue&type=template&id=2955d116&scoped=true&"
import script from "./LinkAccount.vue?vue&type=script&lang=ts&"
export * from "./LinkAccount.vue?vue&type=script&lang=ts&"
import style0 from "./LinkAccount.vue?vue&type=style&index=0&id=2955d116&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2955d116",
  null
  
)

export default component.exports